import { dayjs } from '@weapp/utils';
/**
 * @author  : 王冲
 * @desc    : 应用管理
 */

import { request } from "@weapp/utils";
import { inPCClient, mainHost } from "../utils";

const host = mainHost();
const ETEAMSID = window.ETEAMSID;
//应用列表
export const getAppModules = () => {
  let params = { time: dayjs().valueOf() } as any;
  params.displayClient = inPCClient() ? "pc-weapp" : "pc";
  return request({
    url: `/api/basicserver/menu/queryEmpMenus`,
    method: "get",
    params
  });
};
//应用列表保存--启用、禁用
export const updateMoudles = (data: any) => {
  data.displayClient = inPCClient() ? "pc-weapp" : "pc";
  return request({
    url: `/api/basicserver/updateEmpCustMenuStatus`,
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data,
  });
};
//应用列表保存--排序
export const updateModuleOrder = (data: any) => {
  data?.append?.('displayClient', inPCClient() ? "pc-weapp" : "pc");
  return request({
    url: `/api/basicserver/updateEmpCustMenuOrder`,
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data,
  });
};
//恢复默认设置
export const resetMoudles = () => {
  let data = { displayClient: inPCClient() ? "pc-weapp" : "pc" }
  return request({
    url: `/api/basicserver/resetNavsetting`,
    method: "post",
    data
  });
};

// 获取应用展示设置
export const updateMenuStatus = (data: any) => {
  data.displayClient = inPCClient() ? "pc-weapp" : "pc";
  return request({
    url: `/api/basicserver/app/manage/updateMenuStatus`,
    method: "post",
    data
  });
}

// 获取应用展示设置
export const updateOpenMode = (data: any) => {
  data.displayClient = inPCClient() ? "pc-weapp" : "pc";
  return request({
    url: `/api/basicserver/app/manage/updateOpenMode`,
    method: "post",
    data
  });
}

// 更新个人应用展示设置
export const updateEmpConfig = (data: any) => {
  return request({
    url: `/api/basicserver/app/manage/updateEmpConfig`,
    method: "post",
    data
  });
}

// 获取应用管理--应用展示默认设置
export const queryEmpAppManageConfigs = () => {
  return request({
    url: `/api/basicserver/app/manage/queryEmpAppManageConfigs`,
    method: "get",
  });
}

// 个人应用展示设置-恢复默认设置
export const recoverDefaultSetting = () => {
  const params = { displayClient: inPCClient() ? "pc-weapp" : "pc" }
  return request({
    url: `/api/basicserver/app/manage/recoverDefaultSetting`,
    method: "post",
    params
  });
}

// 个人应用展示设置-同步设置
export const syncEmpAppDisplaySetting = (data: any) => {
  data.displayClient = inPCClient() ? "pc-weapp" : "pc";
  return request({
    url: `/api/basicserver/app/manage/syncEmpAppDisplaySetting`,
    method: "post",
    data
  });
};

// 获取权限列表
export const getModulesPermission = () => {
  return request({
    url: `/api/bs/auth/menu/current-tree`,
    method: "get",
  });
};

// 设为默认设置
export const setDefConfigs = (data: any) => {
  data.displayClient = inPCClient() ? "pc-weapp" : "pc";
  return request({
    url: `/api/basicserver/app/manage/setDefConfigs`,
    method: "post",
    data
  });
};

// 检查是否开启分权
export const checkDetach = () => {
  return request({
    url: `/api/basicserver/menu/check-detach?moduleType=global`,
    method: "get"
  });
}